import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { LastnameSVG } from '@common_components/svg/lastname.svg';

const LastnameIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <LastnameSVG/>
    </div>
  );
};

export { LastnameIcon };